module.exports = MaterialUI.TablePagination;